var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      { staticClass: "col-md-6" },
      [
        _c("list-document-types", {
          directives: [
            {
              name: "validate",
              rawName: "v-validate",
              value: "required",
              expression: "'required'"
            }
          ],
          ref: "relatedDocumentType",
          staticClass: "w-100",
          attrs: {
            autocomplete: "",
            label: "Tipo Documento",
            "data-cy": "relate-document-type",
            name: "relatedDocumentType",
            "data-vv-as": "tipo documento",
            danger: _vm.errors.has("flow-part-1-2.relatedDocumentType"),
            "danger-text": _vm.errors.first("flow-part-1-2.relatedDocumentType")
          },
          model: {
            value: _vm.relatedDocument.type,
            callback: function($$v) {
              _vm.$set(_vm.relatedDocument, "type", $$v)
            },
            expression: "relatedDocument.type"
          }
        })
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "col-md-6" },
      [
        _c("vs-input", {
          directives: [
            {
              name: "validate",
              rawName: "v-validate",
              value: "required",
              expression: "'required'"
            }
          ],
          staticClass: "w-100",
          attrs: {
            label: "Nº Documento",
            "data-cy": "related-document-number",
            name: "relatedDocumentNumber",
            danger: _vm.errors.has("flow-part-1-2.relatedDocumentNumber"),
            "danger-text": _vm.errors.first(
              "flow-part-1-2.relatedDocumentNumber"
            ),
            autocomplete: "off"
          },
          model: {
            value: _vm.relatedDocument.number,
            callback: function($$v) {
              _vm.$set(_vm.relatedDocument, "number", $$v)
            },
            expression: "relatedDocument.number"
          }
        })
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "col-md-12 d-flex align-items-end justify-content-end" },
      [
        _c(
          "vs-button",
          {
            attrs: { "data-cy": "add-relation", color: "primary", icon: "add" },
            on: {
              click: function($event) {
                return _vm.addRelatedDocument()
              }
            }
          },
          [_vm._v(" Agregar relación ")]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }